import * as React from 'react';
import { ISurveyNote, ISurveyNotesActionCreators, SurveyStep } from '../../models';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';
import { HeaderButtonContainer } from '../common';
import { SurveyNoteModal } from '../notes/SurveyNoteModal';
import { SurveyNoteButton } from './SurveyNoteButton';

export interface ISurveyNoteHeaderState {
	showSurveyNoteModal: boolean;
}

export type SurveyNoteHeaderProps = ISurveyNotesActionCreators & ISurveyBuilderState & { withoutContainer?: boolean };

export class SurveyNoteHeader extends React.Component<SurveyNoteHeaderProps, ISurveyNoteHeaderState> {
	constructor(props: SurveyNoteHeaderProps) {
		super(props);
		this.state = { showSurveyNoteModal: false };
		this.toggleSurveyNoteModal = this.toggleSurveyNoteModal.bind(this);
		this.saveSurveyNote = this.saveSurveyNote.bind(this);
		this.deleteSurveyNote = this.deleteSurveyNote.bind(this);
		this.withoutContainer = this.withoutContainer.bind(this);
		this.withContainer = this.withContainer.bind(this);
	}

	public render() {
		return this.props.withoutContainer ? this.withoutContainer() : this.withContainer();
	}

	public withoutContainer() {
		const { currentStep, notes, surveyId } = this.props;
		const currentNote = this.findNote(notes, currentStep);
		return (
			<>
				<SurveyNoteButton
					onClick={this.toggleSurveyNoteModal}
					hasNote={currentNote !== null && currentNote !== undefined}
					isDisabled={surveyId === 0}
				/>
				<SurveyNoteModal
					isOpen={this.state.showSurveyNoteModal}
					surveyNote={currentNote}
					toggleModal={this.toggleSurveyNoteModal}
					saveSurveyNote={this.saveSurveyNote}
					deleteSurveyNote={this.deleteSurveyNote}
				/>
			</>
		);
	}

	public withContainer() {
		return <HeaderButtonContainer>{this.withoutContainer()}</HeaderButtonContainer>;
	}

	public toggleSurveyNoteModal() {
		this.setState({ showSurveyNoteModal: !this.state.showSurveyNoteModal });
	}

	public saveSurveyNote(noteText: string) {
		const { surveyId, currentStep, notes } = this.props;
		const newNote = this.findNote(notes, currentStep) || {
			surveyId,
			step: currentStep,
			text: '',
		};
		newNote.text = noteText;
		this.props.SaveSurveyNote(newNote);
	}

	public deleteSurveyNote() {
		const { currentStep, notes } = this.props;
		const note = this.findNote(notes, currentStep);
		if (note) {
			this.props.DeleteSurveyNote(note);
		}
	}

	private findNote = (notes: ISurveyNote[], step: SurveyStep) => {
		return notes && notes.find((note: ISurveyNote) => note.step === step);
	};
}
